export default __webpack_public_path__ + "static/media/Final milestone.84fc96b3.png";